import { useState, useMemo, useEffect } from "react";
import { useBusinessNoticeTempList } from "~/services/business/notify";

const useNotifySaved = () => {
  const [filterType, setFilterType] = useState<string>("전체");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("최신순");
  const [searchText, setSearchText] = useState("");
  const [searchKeyword, setSearchKeyword] = useState<string | null>(null); // 실제 검색에 사용될 키워드
  const [page, setPage] = useState(1);
  const [accumulatedContent, setAccumulatedContent] = useState<any[]>([]);

  // API 요청 파라미터
  const requestParams = useMemo(
    () => ({
      searchKeyword: searchKeyword, // 검색 버튼 클릭 시에만 업데이트되는 키워드 사용
      cdRecipientType: null,
      noticeType: null,
      page: page,
      size: 10,
      readYn: null,
      sortOrder: selectedType === "최신순" ? "DESC" : "ASC",
      replyYn: null,
    }),
    [page, selectedType, filterType, searchKeyword]
  );

  // API 호출
  const {
    data: apiData,
    isLoading,
    error,
    refetch,
  } = useBusinessNoticeTempList(requestParams);

  // 페이지별 데이터 누적 (스크롤 시 추가 로드)
  useEffect(() => {
    if (!apiData?.content) return;
    const currentPage = requestParams.page;
    setAccumulatedContent((prev) =>
      currentPage === 1 ? apiData.content : [...prev, ...apiData.content]
    );
  }, [apiData, requestParams.page]);

  // 노출용 리스트: 누적된 목록
  const savedData = useMemo(() => accumulatedContent, [accumulatedContent]);

  // 마지막 페이지 여부 (더 불러올 데이터 있는지)
  const hasMore = apiData ? !apiData.last : false;

  const handleSearch = (value: string) => {
    setSearchKeyword(value || null); // 검색 버튼 클릭 시에만 실제 검색 키워드 업데이트
    setPage(1); // 검색 시 첫 페이지로 리셋
    console.log("검색어:", value);
    // searchKeyword가 변경되면 requestParams가 변경되고,
    // useBusinessNoticeTempList가 자동으로 재호출됩니다.
  };

  const onLoad = () => {
    setPage((prev) => prev + 1); // 다음 페이지 로드
    console.log("페이지 로드:", page + 1);
  };

  return {
    savedData,
    hasMore,
    onLoad,
    handleSearch,
    isLoading,
    filterType,
    setFilterType: (type: string) => {
      setFilterType(type);
      setPage(1); // 필터 변경 시 첫 페이지로 리셋
      setSearchKeyword(null); // 필터 변경 시 검색 키워드 초기화
    },
    dropdownOpen,
    setDropdownOpen,
    selectedType,
    setSelectedType: (type: string) => {
      setSelectedType(type);
      setPage(1); // 정렬 변경 시 첫 페이지로 리셋
      setSearchKeyword(null); // 정렬 변경 시 검색 키워드 초기화
    },
    error,
    refetch,
    page,
    searchText,
    setSearchText,
  };
};

export default useNotifySaved;
